/* eslint-disable react/jsx-props-no-spreading */

import type { FC } from 'react';

import type { GlobalHeaderDOMProps } from './GlobalSearch.types';

import { HeaderSearch } from '../Header';
import { getTypedCurrentPage } from './GlobalSearch.utils';
import GlobalSearchBar from './GlobalSearchBar';
import GlobalSearchContext from './GlobalSearchContext';
import GlobalSearchOverlay from './GlobalSearchOverlay';

interface GlobalHeaderProps extends Pick<
    GlobalHeaderDOMProps,
    'currentPage' | 'searchDisabled' | 'headerTheme'
> {
    query?: string;
    performFullSearch?: (query: string, originalQuery?: string) => void;
}

const GlobalSearch: FC<React.PropsWithChildren<GlobalHeaderProps>> = (props) => {
    const initialQuery = props.query || '';
    const typedCurrentPage = getTypedCurrentPage(props.currentPage);

    return (
        <GlobalSearchContext initialQuery={initialQuery} searchFromPage={typedCurrentPage}>
            <GlobalSearchInner {...props} />
        </GlobalSearchContext>
    );
};

const GlobalSearchInner: FC<React.PropsWithChildren<GlobalHeaderProps>> = (props) => {
    const shouldShowGlobalSearchBar = !props.searchDisabled;

    return (
        <>
            {shouldShowGlobalSearchBar && (
                <HeaderSearch
                    searchSlot={<GlobalSearchBar performFullSearch={props.performFullSearch} />}
                />
            )}
            <GlobalSearchOverlay performFullSearch={props.performFullSearch} />
            {props.children}
        </>
    );
};

export default GlobalSearch;
